export const FlashIcon = 'https://boosterprep.s3.amazonaws.com/Icon/flash.svg'
export const StarIcon = 'https://boosterprep.s3.amazonaws.com/Icon/star.svg'
export const DownloadIcon = 'https://boosterprep.s3.amazonaws.com/Icon/download.svg'
